import jQuery from 'jquery';
window.jQuery = jQuery;
$ = jQuery;

import HpaAlertMessages from './lib/HpaAlertMessages';
import { forceInt, forceFloat, getOrderTotal, getCurrenLocaleObj } from './functions';

$(function() {
    const isLive = (window.location.hostname === 'www.hpacademy.com' || window.location.hostname === 'hpacademy.com' ? true : false),
        loadingImageHtml = '<img src="/resources/themes/base/production/images/ajax-loader-button.gif" alt="Processing, please wait ...">',
        currenLocaleObj = getCurrenLocaleObj();

    // GooglePay
    const $googlepayBtn = $('#googlepay-btn');
    if ($googlepayBtn.length && typeof google !== 'undefined' && google) {
        const hpaAlertMessages = new HpaAlertMessages('#googlepay-messages'),
            $googlepayMessagesContainer = $('#googlepay-messages');

        const environment = (isLive ? 'PRODUCTION' : 'TEST');
        // console.log('GPay ENV:', environment);

        const baseRequest = {
            apiVersion: 2,
            apiVersionMinor: 0
        };
        const tokenizationSpecification = {
            type: 'PAYMENT_GATEWAY',
            parameters: {
                gateway: 'windcave',
                gatewayMerchantId: (environment === 'PRODUCTION' ? '2c413094265afbee5af9b3e219ea2ab66dbe1349' : '4e7275853fd1ce9b2d629137f68cc9d8a2369f09'),
            }
        };
        const merchantInfo = {
            merchantName: 'High Performance Academy',
            merchantId: 'BCR2DN4T2OIMVTYY'
        };
        const allowedCardNetworks = ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'];
        const allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];
        const baseCardPaymentMethod = {
            type: 'CARD',
            parameters: {
                allowedAuthMethods: allowedCardAuthMethods,
                allowedCardNetworks: allowedCardNetworks
            }
        };
        const cardPaymentMethod = Object.assign(
            { tokenizationSpecification: tokenizationSpecification },
            baseCardPaymentMethod
        );

        const paymentsClient = new google.payments.api.PaymentsClient({ environment: environment });
        const isReadyToPayRequest = Object.assign({}, baseRequest);
        isReadyToPayRequest.allowedPaymentMethods = [baseCardPaymentMethod];

        paymentsClient.isReadyToPay(isReadyToPayRequest).then(function(response) {
            if (response.result) {
                const button = paymentsClient.createButton({
                    onClick: () => {
                        const { orderId, productName, orderTotal } = hpaCheckoutOrderData();

                        hpaAlertMessages.clearMessages();

                        if (!orderId) {
                            if (!hpaTriggerOverlayClick()) {
                                let errorText = hpaTranslatedtext.windcave.noOrderId;
                                hpaAlertMessages.addMessage(errorText, 'danger', true);
                            }

                            $googlepayBtn.show();

                            return;
                        } else if (orderTotal <= 0) {
                            let errorText = hpaTranslatedtext.windcave.orderTotalTooLow;
                            hpaAlertMessages.addMessage(errorText, 'danger', true);
                            $googlepayBtn.show();

                            return;
                        }

                        // console.log('orderTotal:', orderTotal);

                        const paymentDataRequest = Object.assign({}, baseRequest);
                        paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
                        paymentDataRequest.transactionInfo = {
                            totalPriceStatus: 'FINAL',
                            totalPrice: orderTotal.toFixed(2),
                            currencyCode: 'USD',
                            countryCode: 'NZ'
                        };
                        paymentDataRequest.merchantInfo = merchantInfo;
                        // console.log(paymentDataRequest);

                        paymentsClient.loadPaymentData(paymentDataRequest).then(function(paymentData) {
                            // if using gateway tokenization, pass this token without modification
                            // paymentToken = paymentData.paymentMethodData.tokenizationData.token;
                            const $paymentConfirmationForm = $('#PaymentConfirmationForm_PaymentConfirmationForm'),
                                $wcToken = $('#WcToken'),
                                $step2GooglePay = $('#step2-GooglePay');
                            if ($wcToken.length) $wcToken.val('');
                            $googlepayBtn.hide();
                            hpaAlertMessages.addMessage(hpaTranslatedtext.windcave.processingPurchase + '<br>' + loadingImageHtml, 'info');

                            let token = '';
                            if (paymentData && 'paymentMethodData' in paymentData && 'tokenizationData' in paymentData.paymentMethodData && 'token' in paymentData.paymentMethodData.tokenizationData) {
                                token = paymentData.paymentMethodData.tokenizationData.token;
                            }

                            if (token !== '') {
                                if ($step2GooglePay.length) {
                                    $('#WcToken').val(token);
                                }
                            }

                            $paymentConfirmationForm.submit();
                        }).catch(function(err){
                            console.error('paymentsClient.loadPaymentData error');
                            // show error in developer console for debugging
                            console.error(err);
                        });
                    },
                    allowedPaymentMethods: []
                }); // same payment methods as for the loadPaymentData() API call

                $googlepayBtn.html(button);
            }
        }).catch(function(err) {
            // show error in developer console for debugging
            console.error(err);
        });
    }

    // Credit Card
    if (typeof window.WindcavePayments !== 'undefined' && window.WindcavePayments) {
        const $wcCreditCardBtn = $('#wc-creditcard-btn'),
            $wcCreditCardFieldsWrapper = $('#wc-creditcard-fields-wrapper');
        if ($wcCreditCardBtn.length) {
            const hpaAlertMessages = new HpaAlertMessages('#wc-creditcard-messages'),
                windcaveCreditCardEnv = (isLive ? 'sec' : 'uat');
            // console.log('CC ENV:', windcaveCreditCardEnv);

            const expiryPlaceholderDate = new Date(),
                expiryPlaceholderDateMonth = String(expiryPlaceholderDate.getMonth()).padStart(2, '0'), // Get current day of month (2-digit)
                expiryPlaceholderDateNextYear = String(expiryPlaceholderDate.getFullYear() + 1).slice(-2),
                expiryPlaceholder = expiryPlaceholderDateMonth + '/' + expiryPlaceholderDateNextYear; // // Get next year (2-digit)

            const windcaveCreditCardController = window.WindcavePayments.HostedFields.create(
                {
                    env: windcaveCreditCardEnv,
                    fields: {
                        CardholderName: {
                            container: 'wc-creditcard-name',
                            tabOrder: 1,
                            placeholder: '',
                            length: {
                                jumpToPreviousField: true,
                                jumpToNextField: true
                            }
                        },
                        CardNumber: {
                            container: 'wc-creditcard-number',
                            tabOrder: 2,
                            placeholder: '4111 1111 1111 1111',
                            cardSchemaImagePlacement: 'right',
                            supportedCards: [
                                'visa',
                                'masterCard',
                                'amex',
                                'jcb',
                                'discover',
                                'diners',
                                'unionpay',
                                'farmlands',
                                'other'
                            ],
                            length: {
                                jumpToPreviousField: true,
                                jumpToNextField: true
                            }
                        },
                        ExpirationDate: {
                            container: 'wc-creditcard-expiry',
                            tabOrder: 3,
                            placeholder: expiryPlaceholder,
                            length: {
                                jumpToPreviousField: true,
                                jumpToNextField: true
                            }
                        },
                        CVV: {
                            container: 'wc-creditcard-cvv',
                            tabOrder: 4,
                            placeholder: '123',
                            length: {
                                minimumValidLength: 3,
                                maximumValidLength: 4,
                                // jumpToPreviousField: true,
                                // jumpToNextField: false
                            }
                        },
                    },
                    styles: {
                        'input': {
                            fontFamily: '"museo-sans", sans-serif',
                            backgroundColor: '#ECEBEA',
                            border: 'none',
                            height: 'auto',
                            padding: '15px 12px',
                            fontSize: '16px',
                        },
                        'input-valid': {
                            fontFamily: '"museo-sans", sans-serif',
                            backgroundColor: '#ECEBEA',
                            border: '1px solid #70AE6E',
                            height: 'auto',
                            padding: '15px 12px',
                            fontSize: '16px',
                        },
                        'input-invalid': {
                            fontFamily: '"museo-sans", sans-serif',
                            backgroundColor: '#ECEBEA',
                            border: '1px solid #F15F60',
                            height: 'auto',
                            padding: '15px 12px',
                            fontSize: '16px',
                        },
                        tabOrder: ['cardName', 'cardNumber', 'cardExpiry', 'cardCvc'],
                    }
                },
                30,
                function() {
                    // console.log('WC Credit Card fields created');
                },
                function(errorMessage) {
                    console.log(errorMessage);
                    hpaAlertMessages.addMessage(hpaTranslatedtext.windcave.errorMethodNotAvaialble, 'warning', true);
                    $wcCreditCardBtn.hide();
                    $wcCreditCardFieldsWrapper.hide();
                }
            );

            $wcCreditCardBtn.on('click', function(e) {
                e.preventDefault();

                hpaAlertMessages.clearMessages();

                const { orderId, productName, orderTotal, paymentPlanOption, wcSaveCard, wcPaymentType } = hpaCheckoutOrderData();
                // console.log({wcSaveCard, wcPaymentType});
                // return;
                const $wcCreditCardMethodToken = $('#wc-credit-card-token'),
                    wcCreditCardUsingToken = ($wcCreditCardMethodToken.length && $wcCreditCardMethodToken.is(':checked') ? 1 : 0);
                // console.log({wcCreditCardUsingToken});
                windcaveCreditCardController.validateField(null, function(data) { // onResult
                    // console.log('validateField onResult:', data);

                    let allFieldsValid = true;
                    for (let key in data) {
                        const field = data[key];
                        // console.log({key, isValidationPass: field.isValidationPass});
                        if (!field.isValidationPass) allFieldsValid = false;
                    };

                    // console.log({ allFieldsValid, orderId, productName, orderTotal, paymentPlanOption });
                    // return;

                    if (allFieldsValid || wcCreditCardUsingToken) {
                        $wcCreditCardBtn.hide();
                        $wcCreditCardFieldsWrapper.hide();
                        let processingMessage = (wcPaymentType === 'auth' ? hpaTranslatedtext.windcave.processingAuth : hpaTranslatedtext.windcave.processingPurchase);
                        hpaAlertMessages.addMessage(processingMessage + '<br>' + loadingImageHtml, 'info');

                        $.post('/payment/wc/create-session/?l=' + currenLocaleObj.locale, 'orderId=' + orderId + '&paymentPlanOption=' + paymentPlanOption + '&saveCard=' + wcSaveCard + '&paymentType=' + wcPaymentType + '&token=' + wcCreditCardUsingToken, function(data) {
                            // console.log(data);
                            if (data.status === 1) {
                                if (wcCreditCardUsingToken) {
                                    window.location.href = data.url;
                                } else {
                                    // console.log(windcaveCreditCardController);
                                    windcaveCreditCardController.submit(data.url, 30, function(status) { // onResult
                                        // console.log(status);
                                        if (status === 'done') {
                                            window.location.href = '/payment/wc/cc?sessionId=' + data.sessionId + '&l=' + currenLocaleObj.locale;
                                        }
                                    }, function(data) { // onError
                                        console.log(data);
                                        hpaAlertMessages.addMessage(hpaTranslatedtext.windcave.errorProcessingCard, 'danger', true);
                                        $wcCreditCardBtn.show();
                                        $wcCreditCardFieldsWrapper.show();
                                    });
                                }
                            }

                            if (data.messages && data.messages.length) {
                                hpaAlertMessages.clearMessages();

                                data.messages.forEach(message => {
                                    hpaAlertMessages.addMessage(message.text, message.type, true, true);
                                });

                                $wcCreditCardBtn.show();
                                $wcCreditCardFieldsWrapper.show();
                                return;
                            }

                        }, 'json');
                    }

                }, function(data) { // onError
                    console.log('validateField onError:', data);
                    hpaAlertMessages.addMessage(hpaTranslatedtext.windcave.errorSomethingWentWrong, 'danger');
                });
            });
        }
    }

    // ApplePay
    if (typeof window.ApplePaySession !== 'undefined' && window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
        const $applepayBtn = $('#applepay-btn');
        if ($applepayBtn.length) {
            const hpaAlertMessages = new HpaAlertMessages('#applepay-messages');

            $applepayBtn.on('click', function() {
                const { orderId, productName, orderTotal } = hpaCheckoutOrderData();

                if (!orderId) {
                    if (!hpaTriggerOverlayClick()) {
                        hpaAlertMessages.clearMessages();
                        let errorText = hpaTranslatedtext.windcave.noOrderId;
                        hpaAlertMessages.addMessage(errorText, 'danger', true);
                    }

                    $applepayBtn.show();

                    return;
                } else if (orderTotal <= 0) {
                    hpaAlertMessages.clearMessages();
                    let errorText = hpaTranslatedtext.windcave.orderTotalTooLow;
                    hpaAlertMessages.addMessage(errorText, 'danger', true);
                    $applepayBtn.show();

                    return;
                }

                const requestData = {
                    'countryCode': 'NZ',
                    'currencyCode': 'USD',
                    'merchantCapabilities': [
                        'supports3DS'
                    ],
                    'supportedNetworks': [
                        'visa',
                        'masterCard',
                        'amex',
                        'discover'
                    ],
                    'total': {
                        'label': productName,
                        'type': 'final',
                        'amount': orderTotal.toFixed(2)
                    }
                };

                const session = new ApplePaySession(3, requestData);

                session.onvalidatemerchant = event => {
                    // console.log('onvalidatemerchant');
                    $.post('/payment/wc/ap-validate-merchant/?l=' + currenLocaleObj.locale, 'validationUrl=' + event.validationURL, function(data) {
                      // console.log(data);
                      if (data.status === 1) {
                          session.completeMerchantValidation(data.merchantSession);
                      }

                      if (data.messages && data.messages.length) {
                          hpaAlertMessages.clearMessages();

                          data.messages.forEach(message => {
                              hpaAlertMessages.addMessage(message.text, message.type, true, true);
                          });
                          return;
                      }

                    }, 'json');
                };

                session.onpaymentauthorized = function(event) {
                    // console.log('onpaymentauthorized');
                    const payment = event.payment,
                        $paymentConfirmationForm = $('#PaymentConfirmationForm_PaymentConfirmationForm'),
                        $wcToken = $('#WcToken');

                    // console.log(payment);

                    hpaAlertMessages.clearMessages();

                    if (!$paymentConfirmationForm.length) {
                        hpaAlertMessages.addMessage(hpaTranslatedtext.windcave.errorGeneric + ' [Form]', 'danger', true);
                        return;
                    }

                    if (!$wcToken.length) {
                        hpaAlertMessages.addMessage(hpaTranslatedtext.windcave.errorGeneric + ' [WcToken]', 'danger', true);
                        return;
                    }

                    if (!payment) {
                        hpaAlertMessages.addMessage(hpaTranslatedtext.windcave.errorGeneric, 'danger', true);
                        return;
                    }

                    const tokenObj = payment.token;
                    if (!tokenObj) {
                        hpaAlertMessages.addMessage(hpaTranslatedtext.windcave.errorGeneric, 'danger', true);
                        return;
                    }

                    const token = tokenObj.paymentData;
                    if (!token) {
                        hpaAlertMessages.addMessage(hpaTranslatedtext.windcave.errorGeneric, 'danger', true);
                        return;
                    }

                    // console.log(token);
                    $wcToken.val(JSON.stringify(token));
                    $paymentConfirmationForm.submit();

                    return;
                };
                // console.log('session.begin');
                session.begin();

                return;
            });
        }
    }
});

const hpaCheckoutOrderData = function() {
    const productData = $('.js-ga_checkout').data('ga_productinfo'),
        $OrderID = $('#OrderID'),
        $orderTotal = $('#order-total'),
        $paymentPlanOptions = $('.paymentplan-option'),
        $paymentPlanLink = $('.js-prompt--paymentPlan a'),
        $wcSaveCard = $('#wc-save-card'),
        $wcPaymentType = $('#wc-payment-type');

    let orderId = 0,
        productName = '',
        orderTotal = getOrderTotal(),
        wcSaveCard = 0,
        wcPaymentType = 'purchase';

    if ($OrderID.length) {
        orderId = forceInt($OrderID.val());
    }

    if (productData && productData.length) {
        productName = productData[0].name;
        if (orderId) productName = 'Order ' + orderId + ' - ' + productName;
    }

    // console.log(orderId, productName);
    // return false;
    let paymentPlanOption = '';
    if ($paymentPlanOptions.length && $paymentPlanLink.length) {
        const $paymentPlanOptionChecked = $paymentPlanOptions.filter(':checked');
        if ($paymentPlanOptionChecked.length) {
            if ($paymentPlanOptionChecked.val() !== '' && $paymentPlanOptionChecked.val() !== '0') {
                paymentPlanOption = $paymentPlanOptionChecked.val();
            }
        }
    }

    if ($wcSaveCard.length && $wcSaveCard.is(':checked')) {
        wcSaveCard = 1;
    }

    if ($wcPaymentType.length && $wcPaymentType.val() === 'auth') {
        wcPaymentType = 'auth';
    }

    return { orderId, productName, orderTotal, paymentPlanOption, wcSaveCard, wcPaymentType };
};

const hpaTriggerOverlayClick = function() {
    let messageShown = false;
    const $paymentMethodsWrapper = $('.payment-methods');
    if ($paymentMethodsWrapper.length) {
        const $paymentMethodsOverlay = $paymentMethodsWrapper.find('.payment-methods__not-logged-in-overlay');
        if ($paymentMethodsOverlay.length && $paymentMethodsOverlay.is(':visible')) {
            messageShown = true;
            $paymentMethodsOverlay.trigger('click');
        }
    }

    return messageShown;
};



// WEBPACK FOOTER //
// ./js/windcave.js